import SFXButtonComponent from "../../SFXButtonComponent";
import React, {Fragment} from "react";
import ToastHelper from "../../../utils/ToastHelper";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import CardPaymentService from "../../../services/Transaction/CardPaymentService";
import SFXRoundedButton from "../../SFXRoundedButton";
import AuthorisationService from "../../../services/AuthorisationService";
import SFXLoadingComponent from "../../SFXLoadingComponent";
import UserSessionService from "../../../services/UserSessionService";

export default class CardPaymentButton extends React.Component {

    constructor(props) {
        super(props);

        this.hasActiveBankCard = UserSessionService.getCustomerProfile().hasActiveBankCard;
        this.className = this.props.isMobile ? "mobile" : "browser";

        this.state = {
            paymentReference: props.paymentReference,
            amount: props.amount,
            paymentModalOpen: false,
            isLoading: true,
            openAuth: {},
            isAuthOpen: true
        }
    }

    initiatePayment() {
        this.setState({
            isLoading: true,
            paymentModalOpen: true
        }, () => {
            AuthorisationService.retrieveAuthorisationForTransactionIdAndPaymentReference(this.props.transactionId, this.props.paymentReference).then((response) => {
                    if (response["has-authorisation"] === true) {
                        this.setState({
                            openAuth: response.authorisation,
                            isAuthOpen: true,
                            isLoading: false
                        });
                        return;
                    }
                    this.setState({
                        isLoading: false,
                        isAuthOpen: false
                    });
                },
                (error) => {
                    ToastHelper.formatError(error);
                }
            );
        });
    }

    requestPayment() {
        this.setState({
                isLoading: true
            },
            () => CardPaymentService.requestPayment(this.state.paymentReference).then(
                (response) => {
                    if (response['error-code'] || response.errors) {
                        if (this.props.onError) {
                            this.props.onError(response);
                        }
                    } else if (response["message"]) {
                        ToastHelper.formatError(response["message"]);
                    } else {
                        if (this.props.onPaymentSuccess) {
                            this.props.onPaymentSuccess()
                        } else {
                            ToastHelper.success("Payment request sent.")
                        }
                    }
                    this.setState({
                            paymentModalOpen: false
                        }
                    );
                }
            )
        );

    }

    closeModal() {
        this.setState({
            paymentModalOpen: false
        })
    }

    render() {
        return <Fragment>
            {this.renderButton()}
            {this.state.paymentModalOpen && this.renderPaymentModal()}
        </Fragment>

    }

    renderButton() {
        if (this.hasActiveBankCard) {
            return <Fragment>
                <SFXRoundedButton
                    value={"Pay with Sikhona Card"}
                    onClick={this.initiatePayment.bind(this)}
                />
            </Fragment>
        }
    }

    renderPaymentModal() {
        return <Fragment>
            <Modal toggle={this.closeModal.bind(this)} isOpen={true} className={'modal-primary modal-md'}>
                {this.getModalContent()}
            </Modal>
        </Fragment>
    }

    getModalContent() {
        if (this.state.isLoading) {
            return <SFXLoadingComponent/>
        } else if (this.state.isAuthOpen) {
            return <Fragment>
                <ModalHeader className={this.className + '_modal_header'}>
                    Sikhona card payment.
                </ModalHeader>
                <ModalBody>
                    It seems someone is already trying to pay for this transaction.
                    Please wait 5 minutes and try again.
                </ModalBody>
                <ModalFooter>
                    <SFXButtonComponent color="secondary" onClick={
                        () => {
                            this.setState({paymentModalOpen: false})
                        }
                    }>
                        Close
                    </SFXButtonComponent>
                </ModalFooter>
            </Fragment>
        } else {
            return <Fragment>
                <ModalHeader className={this.className + '_modal_header'}>
                    Sikhona card payment confirmation.
                </ModalHeader>
                <ModalBody>
                    You are about to make a payment amount of R{this.state.amount} using payment
                    reference {this.state.paymentReference}.
                </ModalBody>
                <ModalFooter>
                    <SFXButtonComponent color="secondary" onClick={
                        () => {
                            this.setState({paymentModalOpen: false})
                        }
                    }>
                        Cancel
                    </SFXButtonComponent>
                    <SFXButtonComponent color="primary" onClick={this.requestPayment.bind(this)}>
                        Confirm
                    </SFXButtonComponent>
                </ModalFooter>
            </Fragment>
        }
    }
}
